import { mutateApi } from "src/utils/api/ApiMethods"

export const createShortTermWaitlistEntry = async ({ marinaSlug, data }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/waitlists/short_term`,
    method: "POST",
    data,
  })
}
